export const GET_ACTIVITY_DATA = 'GET_ACTIVITY_DATA';
export const GET_ACTIVITY_DATA_SUCCESS = 'GET_ACTIVITY_DATA_SUCCESS';
export const GET_ACTIVITY_DATA_ERROR = 'GET_ACTIVITY_DATA_ERROR';
export const ASSETS_LOADED_SUCCESS = 'ASSETS_LOADED_SUCCESS';
export const ASSETS_LOADED_ERROR = 'ASSETS_LOADED_ERROR';
export const START_ACTIVITY = 'START_ACTIVITY';
export const NEXT_ACTIVITY = 'NEXT_ACTIVITY';
export const REPEAT_ACTIVITY = 'REPEAT_ACTIVITY';
export const RESET_ACTIVITY_STORE = 'RESET_ACTIVITY_STORE';
export const ACTIVITY_FLOW_COMPLETE = 'ACTIVITY_FLOW_COMPLETE';
export const SET_LEVEL_OVERRIDE = 'SET_LEVEL_OVERRIDE';

export const TOGGLE_VIDEO = 'TOGGLE_VIDEO';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const SKIP_RECORDING_ACTIVITY = 'SKIP_RECORDING_ACTIVITY';
export const COUNTERS_FLIP_CARD = 'COUNTERS_FLIP_CARD';
export const RESET_RESTARTING_FLAG = 'RESET_RESTARTING_FLAG';
